import * as React from 'react'

function SvgWalkable(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width={31} height={31} viewBox="0 0 17 17" {...props}>
			<path
				fill="currentColor"
				d="M12.298 13.574c-.205.09-.288.307-.626.267-.309.347-.57.74-1.163.805.082-.393.243-.711.448-.983-.65-.99-1.832-1.45-2.058-2.862-.425.588-.845 1.182-1.163 1.877-.582.402-.546 1.422-1.34 1.61-.238.027-.296-.124-.27-.356-.432-.105-.793-.28-1.163-.448.031-.297.516-.142.806-.18.87-1.427 1.813-2.776 2.504-4.382-.19-.258-.002-.891-.179-1.162-.749.325-1.435.71-2.057 1.162-.198.049-.128-.171-.268-.18-.37-.012-.14.577-.626.448-.064-.332.152-.384.09-.715.628-.593 1.398-1.046 2.056-1.61.331-.832.548-1.778 1.254-2.237-.038-.261-.307-.29-.449-.446-.05-.415-.168-.888-.093-1.305a.465.465 0 01.008-.036c.074-.303.386-.425.695-.455.415-.04.961.075 1.095.52.082.276.018.564-.07.828-.022.06-.295.715-.293.715 1.047.505 1.973 1.129 2.683 1.968.112.455.04 1.095.18 1.52-.018.31-.317.34-.359.626.005.324.223.434.27.717-1.433-.28-.494-2.375-1.7-2.863-.339.869.343 1.758-.18 2.416-.32 2.555 1.292 3.18 1.968 4.74z"
			/>
		</svg>
	)
}

export default SvgWalkable
